import styled from "styled-components";
import { TipMouseOutEvent, TipMouseOverEvent } from "../Tooltip/Tooltip";

function TopRagnarok() {
    return(
            <VoteContainer>
                <a href="https://www.topragnarok.org/votar/id8954/" target="_blank" title="Vote no servidor TOP">
                <Banner
                onMouseOver={(event) => TipMouseOverEvent(event, "<b>Votar<br>TopRagnarok Org</b>", "rgba(173, 35, 35, 1)")} onMouseLeave={() => TipMouseOutEvent()}
                src="https://www.lionsragnarokserver.net/downloads/banner1-top.png"
                alt="Clique e vote. Top Ragnarok Online Brasil"
                title="Clique e vote. Top Ragnarok Online Brasil" border="0">
                <img src="https://www.topragnarok.org/image/onepixel.png" border="0"/>
                </Banner>
                </a>
            </VoteContainer>             
    )
}

export default TopRagnarok;

const VoteContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    margin-bottom: 0px;
`

const H3 = styled.span`
    font-size: 14pt;
    font-weight: bold;
`

const Banner = styled.div`
    margin: 0;
    padding: 0;
    background-image: url(${props => props.src});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 500px;
    height: 63px;
    scale: 1;
    transition: .3s ease-in-out;
    //border: 1px solid white;
    opacity: 1;

    &:hover {
    scale: 1.1;
    box-shadow: 2px 2px 5px 0 black;
    opacity: 1;
    }

     cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`